import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import UiTextField from 'ui-components/ui-text-field/UiTextField';
import UiButton from 'ui-components/ui-button/UiButton';
import classNames from 'classnames';
import { isTagContainsSpecialCharacters } from 'utils/validation';
import { StyledTag, StyledTagPopover } from './Tag.styles';

const Tag = ({ onChange = () => {}, value = '', ...props }) => {
  const { t } = useTranslation();
  const [tagValue, setTagValue] = useState('');
  const [error, setError] = useState(false);
  const [selectedColor, setSelectedColor] = useState('#a6a9af');
  const [selectedTags, setSelectedTags] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (value) {
      try {
        setSelectedTags(JSON.parse(value));
      } catch (error) {
        //
      }
    }
  }, [value]);

  /**
   * باز کردن پاپ‌اور رنگ های تگ
   * @param {*} event
   */
  const handleOpenColorPicker = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   * بستن پاپ‌اوور رنگ های تگ
   */
  const handleCloseColorPicker = () => {
    setAnchorEl(null);
  };

  // مربوط به popover
  const openColorPicker = Boolean(anchorEl);
  // مربوط به popover
  const idColorPicker = openColorPicker ? 'simple-popover' : undefined;

  /**
   * انتخاب تگ
   */
  const handleSelectTag = () => {
    const trimmedTagValue = tagValue.trim();
    const isDuplicate = selectedTags.some(
      (tag) => tag.text === tagValue.trim()
    );
    const isTooLong = trimmedTagValue.length > 50;

    if (
      isTooLong ||
      !trimmedTagValue ||
      isTagContainsSpecialCharacters(tagValue) ||
      isDuplicate
    ) {
      setError(true);
      return;
    }

    const tag = {
      text: trimmedTagValue,
      color: selectedColor,
      id: selectedTags?.length || 0,
    };
    const tags = [...selectedTags, tag];
    setTagValue('');
    setSelectedTags(tags);
    onChange(tags);
  };

  /**
   * حذف تگ انتخاب شده
   * @param {*} id
   */
  const handleRemoveTag = (id) => {
    const _selectedTags = selectedTags.filter((x) => x.id != id);
    setSelectedTags(_selectedTags);
    onChange(_selectedTags);
  };

  /**
   * انتخاب رنگ از پاپ اوور
   * @param {*} color
   */
  const handleSelectedColor = (color) => {
    setSelectedColor(color);
    setAnchorEl(null);
  };

  const handleChange = (e) => {
    setError(false);
    setTagValue(e.target.value);
  };

  return (
    <StyledTag>
      <div className='tag-component'>
        <div className='flex tag-component-wrapper'>
          <div className='tag-section flex'>
            <UiTextField
              value={tagValue}
              onChange={handleChange}
              onKeyUp={(e) => {
                if (e.keyCode == 13) {
                  handleSelectTag();
                }
              }}
              InputProps={{
                endAdornment: (
                  <>
                    <span
                      className='color-circle'
                      onClick={handleOpenColorPicker}
                      style={{ backgroundColor: selectedColor }}
                    ></span>

                    <UiIcon
                      aria-describedby={idColorPicker}
                      icon='ri-arrow-down-s-fill'
                      className='tag-icon'
                      onClick={handleOpenColorPicker}
                    />
                  </>
                ),

                inputProps: {
                  'data-testid': `${props?.['data-testid']}-ui-tag-colors-input`,
                },
              }}
              error={error}
            />

            <StyledTagPopover
              paperStyles={{
                width: 258,
                padding: '14px 10px',
                borderRadius: '8px',
              }}
              id={idColorPicker}
              open={openColorPicker}
              anchorEl={anchorEl}
              onClose={handleCloseColorPicker}
            >
              <div
                className='flex ui-tag-colors'
                data-testid={`${props?.['data-testid']}-ui-tag-colors`}
              >
                <span
                  onClick={() => handleSelectedColor('#a6a9af')}
                  className={classNames(
                    'color1',
                    selectedColor === '#a6a9af' ? 'active' : ''
                  )}
                ></span>
                <span
                  onClick={() => handleSelectedColor('#f88989')}
                  className={classNames(
                    'color2',
                    selectedColor === '#f88989' ? 'active' : ''
                  )}
                ></span>
                <span
                  onClick={() => handleSelectedColor('#ce82c6')}
                  className={classNames(
                    'color3',
                    selectedColor === '#ce82c6' ? 'active' : ''
                  )}
                ></span>
                <span
                  onClick={() => handleSelectedColor('#fc9f14')}
                  className={classNames(
                    'color4',
                    selectedColor === '#fc9f14' ? 'active' : ''
                  )}
                ></span>
                <span
                  onClick={() => handleSelectedColor('#547a9c')}
                  className={classNames(
                    'color5',
                    selectedColor === '#547a9c' ? 'active' : ''
                  )}
                ></span>
                <span
                  onClick={() => handleSelectedColor('#199ba3')}
                  className={classNames(
                    'color6',
                    selectedColor === '#199ba3' ? 'active' : ''
                  )}
                ></span>
                <span
                  onClick={() => handleSelectedColor('#97bd66')}
                  className={classNames(
                    'color7',
                    selectedColor === '#97bd66' ? 'active' : ''
                  )}
                ></span>
                <span
                  onClick={() => handleSelectedColor('#738adc')}
                  className={classNames(
                    'color8',
                    selectedColor === '#738adc' ? 'active' : ''
                  )}
                ></span>
                <span
                  onClick={() => handleSelectedColor('#f16063')}
                  className={classNames(
                    'color9',
                    selectedColor === '#f16063' ? 'active' : ''
                  )}
                ></span>
              </div>
            </StyledTagPopover>
          </div>
          <UiButton
            className='submit-tag'
            onClick={handleSelectTag}
            data-testid={`${props?.['data-testid']}-ui-tag-colors-submit-btn`}
          >
            {t('bulletin:saveHighlight')}
          </UiButton>
        </div>

        <div className={classNames('text', error && 'error')}>
          {error
            ? t('bulletin:error.useKeyboardToHighlight')
            : t('bulletin:useKeyboardToHighlight')}
        </div>
        <div
          className='tags flex'
          data-testid={`${props?.['data-testid']}-ui-tag-colors-selected-tags`}
        >
          {selectedTags?.map((item, index) => {
            return (
              <span key={`tag${index}`} className='tag'>
                <span
                  className='tag-label flex'
                  style={{
                    backgroundColor: `${item?.color}20`,
                    borderColor: item?.color,
                  }}
                >
                  <span style={{ color: item?.color }}>{item?.text}</span>
                  <UiIcon
                    icon='ri-close-line'
                    color='#454545'
                    onClick={() => handleRemoveTag(item?.id)}
                  />
                </span>
              </span>
            );
          })}
        </div>
      </div>
    </StyledTag>
  );
};

Tag.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  'data-testid': PropTypes.string,
};

export default Tag;
